import Phaser from 'phaser';
import './styles.css';
import './config/tunables';
import { FPS_LIMIT, RENDER_HEIGHT, RENDER_WIDTH } from './config/rendering';
import { BootScene } from './scenes/BootScene';
import { GameScene } from './scenes/GameScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'app',
  backgroundColor: '#17140f',
  transparent: true,
  physics: {
    default: 'arcade',
    arcade: {
      debug: false,
    },
  },
  render: { antialias: true, roundPixels: true },
  fps: {
    limit: FPS_LIMIT,
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: RENDER_WIDTH,
    height: RENDER_HEIGHT,
  },
  scene: [BootScene, GameScene],
};

new Phaser.Game(config);
